import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import router from "next/router";
import GroupsIcon from '@mui/icons-material/Groups';
import WorkIcon from '@mui/icons-material/Work';

//
const MyMenu = styled(Menu)({
    ".MuiMenu-paper": {
        background: "#292c2e",
        color: "white",
        "& li": {
            transition: "all .1s linear",
            fontWeight: 700,
            fontSize: "14px",
            padding: "8px 25px 8px 25px",
            "&:hover": {
                //transform: "scale(1.1, 1.1)",
                background: "#383d40"
            }
        }
    }
});

// Component
function AboutUsMenu(props: any) {

    function aboutUsHandler(e: any) {
        router.push("/#team");
        props.handleClose(e);
    }

    function careersHandler(e: any) {
        router.push("/#joinus");
        props.handleClose(e);
    }

    return (
        <Box>
            <MyMenu
                id="community-menu"
                anchorEl={props.anchorEl}
                open={props.open}
                onClose={props.handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: props.horizontal,
                }}>

                <MenuItem onClick={(e) => aboutUsHandler(e)}><GroupsIcon sx={{ color: "white", marginRight: "11px" }} />
                    Team
                </MenuItem>

                <MenuItem onClick={(e) => careersHandler(e)}><WorkIcon sx={{ color: "white", marginRight: "11px" }} />
                    Careers
                </MenuItem>
            </MyMenu>
        </Box>
    );
}

// Default style!
const AboutUsMenuStyled = styled(AboutUsMenu)({

});

// Export
export default AboutUsMenuStyled;
